import { cardHeaderClasses, typographyClasses, type Theme } from "@mui/material"
import { SimpleWidgetCardTheme } from "../../../definitions/components.types"
import { simpleWidgetCardClasses } from "../../../themeTypes"

export const createSimpleWidgetCardTheme = (_: Theme): SimpleWidgetCardTheme => ({
    styleOverrides: {},
    variants: [
        {
            props: { widgetVariant: "dashboard" },
            style: {
                padding: "10px",
                [`.${simpleWidgetCardClasses.card}`]: {
                    borderRadius: "3px",
                    [`.${simpleWidgetCardClasses.header}`]: {
                        [`.${cardHeaderClasses.content}`]: {
                            [`.${typographyClasses.root}`]: {
                                fontSize: "1.5rem",
                            },
                        },
                    },

                    [`.${simpleWidgetCardClasses.actions}`]: {
                        padding: "0 1em 1em",
                    },
                },
            },
        },
    ],
})
